<template functional>
  <footer class="footer">
    <div class="footer__logo small-6 large-4">
        <img src="../../assets/svmic-logo-white.png"
             class="footer__logo__img"
             alt="SVMIC Logo"/>
      </div>
      <div class="footer__info">
        <p>
          <a href="https://www.svmic.com/privacy-policy"
             target="_blank">
            Privacy Policy
          </a>
          &nbsp;|&nbsp;Copyright&nbsp;©&nbsp;2023 SVMIC
        </p>
        <p>
          In order to best serve all of our policyholders, SVMIC is committed to
          accessibility of our website. If you experience issues, please contact us
          at <a href="tel:8003422239">(800) 342-2239</a>.
        </p>
      </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
};
</script>>
